<template>
  <FormViewBase title="Email address verified!">
    <template #default>
      <v-row>
        <v-col cols="12" class="mx-auto text-center">
          <v-progress-circular
            indeterminate
            size="20"
            width="2"
            color="amber lighten-2"
            class="mx-auto"
          />
          <h3 class="grey--text text--darken-2 text-h6">Logging you in...</h3>
        </v-col>
        <v-col>
          <div class="text-center font-italic"
            >Use the button below if you're not redirected in a few
            seconds.</div
          >
          <BtnBaseBlue :to="{ name: redirectRoute }" block
            >My Dashboard</BtnBaseBlue
          >
        </v-col>
      </v-row>
    </template>
  </FormViewBase>
</template>

<script>
import { mapActions } from 'vuex'
import RouteNames from '@/constants/RouteNames'
import BtnBaseBlue from '@/components/BtnBaseBlue'
import FormViewBase from '@/views/FormViewBase'
export default {
  name: 'EmailVerificationSuccessView',
  components: { FormViewBase, BtnBaseBlue },
  async mounted() {
    try {
      let isMerchantForShop = await this.checkIsMerchantForShop(
        this.$route.query.api_token
      )
      if (isMerchantForShop) {
        this.redirectRoute = RouteNames.Merchant.Manage.ORDERS
      } else {
        this.redirectRoute = RouteNames.Customer.ORDERS_INDEX
      }
      this.$router.push({ name: RouteNames.Customer.ORDERS_INDEX })
    } catch (error) {
      Promise.reject(error)
    }
  },
  methods: {
    ...mapActions('auth', ['checkIsMerchantForShop']),
  },
  data() {
    return {
      redirectRoute: null,
    }
  },
}
</script>
